// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"1a0f8ba9","237":"2f38d5ee","350":"978cb671","450":"ccc33342","499":"3c05f453","638":"3938817d","965":"00edced3"}[chunkId] + ".chunk.js";
};